import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [ MatButtonModule, MatCheckboxModule ],
  exports: [ MatButtonModule, MatCheckboxModule ]
})
export class MaterialModule { }



// WEBPACK FOOTER //
// D:/WebSites/BubbleDown/bubbledown-app/src/app/shared-modules/material.module.ts